import { render, staticRenderFns } from "./ml-model.vue?vue&type=template&id=324646ac"
import script from "./ml-model.vue?vue&type=script&lang=js"
export * from "./ml-model.vue?vue&type=script&lang=js"
import style0 from "./ml-model.vue?vue&type=style&index=0&id=324646ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports